import api from "./api";

/**
 * @description Servicio para /labs y /lab-routines.
 * Gestiona determinaciones de laboratorio y rutinas.
 */
const labCatalogService = {};

/**
 * @description Obtiene listado de determinaciones con búsqueda
 * @param {Object} params
 * @returns {Promise<Array>}
 */
labCatalogService.getLabs = function (params) {
  return api.get("/labs", { params }).then((res) => res.data);
};

/**
 * @description Crea una determinación
 * @param {Object} data
 * @returns {Promise<Object>}
 */
labCatalogService.createLab = function (data) {
  return api.post("/labs", data).then((res) => res.data);
};

/**
 * @description Actualiza una determinación
 * @param {string} id
 * @param {Object} data
 * @returns {Promise<Object>}
 */
labCatalogService.updateLab = function (id, data) {
  return api.put(`/labs/${id}`, data).then((res) => res.data);
};

/**
 * @description Elimina una determinación (soft delete)
 * @param {string} id
 * @returns {Promise<void>}
 */
labCatalogService.deleteLab = function (id) {
  return api.delete(`/labs/${id}`);
};

/**
 * @description Obtiene todas las rutinas de laboratorio
 * @param {Object} params
 * @returns {Promise<Array>}
 */
labCatalogService.getRoutines = function (params) {
  return api.get("/lab-routines", { params }).then((res) => res.data);
};

/**
 * @description Crea una rutina de laboratorio
 * @param {Object} data
 * @returns {Promise<Object>}
 */
labCatalogService.createRoutine = function (data) {
  return api.post("/lab-routines", data).then((res) => res.data);
};

/**
 * @description Actualiza una rutina
 * @param {string} id
 * @param {Object} data
 * @returns {Promise<Object>}
 */
labCatalogService.updateRoutine = function (id, data) {
  return api.put(`/lab-routines/${id}`, data).then((res) => res.data);
};

/**
 * @description Elimina una rutina (soft delete)
 * @param {string} id
 * @returns {Promise<void>}
 */
labCatalogService.deleteRoutine = function (id) {
  return api.delete(`/lab-routines/${id}`);
};

export default labCatalogService;
